export function SortCompareName(a, b) {
    // name
    let nameA = a.name.toLowerCase()

    let nameB = b.name.toLowerCase()

    // sorting by name
    if (nameA < nameB) return -1
    if (nameA > nameB) return 1

    return 0 // default return value (no sorting)
}

export function SortCompareDate(a, b) {
    // date
    let createAtA = a.created_at

    let createAtB = b.created_at

    // sorting by date
    if (createAtA < createAtB) return -1
    if (createAtA > createAtB) return 1

    return 0 // default return value (no sorting)
}

export function SortCompareFileType(a, b) {
    // type
    let fileTypeA = a.file_type

    let fileTypeB = b.file_type

    // sorting by file type
    if (fileTypeA < fileTypeB) return -1
    if (fileTypeA > fileTypeB) return 1

    return 0 // default return value (no sorting)
}
